// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"jV","modalBox":"jV","modal-mask":"jW","modalMask":"jW","close-btn":"jX","closeBtn":"jX","container":"jY","content":"jZ","title":"j0","subTitle":"j1","detail":"j2"};